import { render, staticRenderFns } from "./ThreadTab.vue?vue&type=template&id=f983fe68&scoped=true&"
import script from "./ThreadTab.vue?vue&type=script&lang=js&"
export * from "./ThreadTab.vue?vue&type=script&lang=js&"
import style0 from "./ThreadTab.vue?vue&type=style&index=0&id=f983fe68&lang=scss&scoped=true&"
import style1 from "./ThreadTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983fe68",
  null
  
)

export default component.exports